import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: ${({ theme }) => theme.colors.white};
  padding: 16px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.black3};
  position: relative;
`;

export const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    flex-direction: row;
    align-items: center;
  }
`;

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;
  min-width: 200px;
`;

export const ItemTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.black9};
`;

export const ItemValue = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.black9};
`;

export const ItemImage = styled.img`
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 50%;
`;

export const ItemDescription = styled.div`
  font-size: 14px;
  font-weight: 400;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.black3};
  padding: 8px;
  color: ${({ theme }) => theme.colors.black9};
  background-color: ${({ theme }) => theme.colors.white};
  min-width: 300px;
  min-height: 100px;
  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    min-width: 400px;
  }
`;

export const Actions = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
`;
